import { render, staticRenderFns } from "./FeIngredienta.vue?vue&type=template&id=12c924a9&"
import script from "./FeIngredienta.vue?vue&type=script&lang=js&"
export * from "./FeIngredienta.vue?vue&type=script&lang=js&"
import style0 from "./FeIngredienta.vue?vue&type=style&index=0&id=12c924a9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports